import BaseModelInstance from './base.model'
import { UniversityLocation as ModelDefinition } from './model-definitions'

class UniversityLocation extends BaseModelInstance {
  afterSet = (key, value) => {}

  constructor(attribs) {
    super(ModelDefinition, attribs)
  }
}

export default UniversityLocation
